import { IConfiguration } from '../../domain/conf'
import { logger } from '../../utils/common/logger'
import { IIdentityServiceAdapter, ISubscriberServiceAdapter } from './adapters/adapter'
import { LoginRadiusAdapter } from './adapters/loginradius'
import { NavigaAuth0Adapter } from './adapters/naviga-auth0'
import { PianoLoginRadiusSubscriberService } from './adapters/piano/piano-login-radius'

export class IdentityFactory {
    public static async getIdentityInstance(conf: IConfiguration): Promise<IIdentityServiceAdapter> {
        if (!conf.identity) {
            return undefined
        }
        let adapter

        if (conf.identity.sso.vendor === 'naviga_auth0') {
            adapter = new NavigaAuth0Adapter(conf)
            adapter.init()
        } else if (conf.identity.sso.vendor === 'loginradius') {
            adapter = new LoginRadiusAdapter(conf)
            await adapter.init()
        }
        return adapter
    }

    public static async getSubscriberInstance(conf: IConfiguration): Promise<ISubscriberServiceAdapter> {
        if (!conf.identity) {
            return undefined
        }
        if (!conf.identity.subscriber) {
            return undefined
        }
        let adapter
        let pianoAbTestEnabled = false
        if (conf.page && conf.page.abTest && conf.page.abTest.hasOwnProperty('piano_experience')) {
            pianoAbTestEnabled = conf.page.abTest.piano_experience.enabled || false
        }
        if (conf.identity.sso.vendor === 'loginradius') {
            if ( conf.identity.logo.default.length > 0 && conf.identity.logo.default[0] === '/') {
                conf.identity.logo.default = `${window.location.origin}${conf.identity.logo.default}`
            }
            adapter = new PianoLoginRadiusSubscriberService(conf.identity.subscriber,
                conf.identity.logo,
                conf.identity.exclusiveNewsletter,
                conf.page.isPremium,
                conf.page.isRegistration,
                conf.page.isPaywallWhitelisted,
                pianoAbTestEnabled,
                conf.identity.showOnboardPages
            )
            try {
                await adapter.initialize()
            } catch (e) {
                logger('error', 'Failed to initialize subscriber service', e)
            }

        }
        return adapter
    }
}
